import type { HolisticSummary } from '@fruitful/types';

import { requestBuilder } from '../../../http/RequestBuilder';

const useGetHolisticSummary = requestBuilder.query<
    HolisticSummary,
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/memberships/${membershipId}/holistic-summary`,
    queryKey: ({ membershipId }) => `getHolisticSummary/${membershipId}`,
});

export const getHolisticSummaryQueryKey = ({
    membershipId,
}: {
    membershipId?: string | null;
}): string => `getHolisticSummary/${membershipId ?? ''}`;

interface MembershipHolisticSummary {
    membershipId: string | null;
    holisticSummary: HolisticSummary | undefined;
}

export const useMembershipHolisticSummary = (
    membershipId: string | null,
): {
    membershipHolisticSummary: MembershipHolisticSummary;
    isLoadingHolisticSummary: boolean;
    isHolisticSummaryError: boolean;
} => {
    const {
        data: holisticSummary,
        isLoading,
        isError,
        error,
    } = useGetHolisticSummary(
        {
            membershipId: membershipId ?? '',
        },
        {
            enabled: membershipId != null,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 60, // 1 hour
        },
    );

    if (isError) {
        console.error('useMembershipHolisticSummary error:', error);
        console.error('useMembershipHolisticSummary error details:', {
            membershipId,
            error: error?.message,
            errorStack: error?.stack,
        });
    }

    return {
        membershipHolisticSummary: {
            membershipId,
            holisticSummary,
        },
        isLoadingHolisticSummary: isLoading,
        isHolisticSummaryError: isError,
    };
};
